import { Component, Input } from '@angular/core';

/** Titled form section: icon + uppercase heading + optional `[sectionActions]`, divided from its siblings. */
@Component({
  selector: 'app-form-section',
  template: `
    <section class="jf-sec">
      <header class="jf-sec__head">
        <i *ngIf="icon" class="pi" [ngClass]="icon"></i>
        <h3>{{ title }}</h3>
        <div class="jf-sec__actions"><ng-content select="[sectionActions]"></ng-content></div>
      </header>
      <ng-content></ng-content>
    </section>
  `,
})
export class FormSectionComponent {
  @Input() icon = '';
  @Input() title = '';
}
